<template>
  <li>
    <template v-if="option.click">
      <button :class="setTheme" class="group flex rounded-md items-center w-full px-2 py-2 text-sm" @click="option.click($store)">
        <base-icon v-if="option.icon" :name="option.icon" class="mr-2" :ariaHidden="true"/>
        {{ option.name }}
      </button>
    </template>
    <template v-else>     
      <router-link
        :to="{ name: option.path }"
        :class="setTheme"
        class="focus:outline-none group flex rounded-md items-center w-full px-2 py-2 text-sm"
      >
        <base-icon v-if="option.icon" :name="option.icon" class="mr-2" :ariaHidden="true"/>
        {{ option.name }}
      </router-link>
    </template>
  </li>
</template>
<script>
export default {
  name: 'item-nav',
  props: {
    option: {
      type: [Array, Object],
      required: true
    },
    theme: {
      type: String,
      default: 'light'
    }
  },
  computed: {
    setTheme: function () {
      return {
        'bg-white dark:bg-darkblue dark:text-darkblue-200 lg:dark:bg-darkblue-900 hover:bg-primary-50 dark:hover:bg-darkblue hover:text-primary-800 active:bg-primary-100 dark:active:bg-darkblue-600 dark:focus:bg-darkblue-600 dark:focus:text-primary':
          this.theme === 'light',
        'bg-secondary text-white hover:bg-secondary-900 active:bg-secondary focus:bg-secondary-900':
          this.theme === 'dark',
        'cursor-not-allowed': this.disabled
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
